export const getApiFields = (state) => state.companyDtls.clientApiFields;
